import React, { FC, Dispatch, useEffect } from 'react'
import {
  PAYMENT_STATUS,
  TERMINAL_EVENT,
  TerminalEventMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk'
import { PaymentEvent } from '../hooks/use-lspay-payment-server-reducer/types'
import { Processing } from '../../../modal-states/Processing'
import { captureTransactionWithRetry } from '../../../../helpers/lspayTransaction'
import {
  LSPAY_ERROR,
  TRANSACTION_TYPE,
} from '../../../../helpers/lspayConstants'
import { TAG, trackLSPayServerError } from '../../../../hooks/errorTracking'
import { SwiperError, TerminalInfo } from '../../../../helpers/lspay.types'
import { getTotalSurchargeAmountFromTenders } from '../../../../../../../functions/payments'
import { useErrorMessages } from '../../../../hooks/useErrorMessages'

interface CaptureTransactionProps {
  paymentIntentId: string
  registerId: string
  registerSalePaymentId: string
  dispatch: Dispatch<PaymentEvent>
  setDisableCNP: (disableCNP: boolean) => void
  terminalMonitoringInstance: TerminalEventMonitoring | null
  terminalInfo: TerminalInfo
}
export const CaptureTransaction: FC<CaptureTransactionProps> = ({
  paymentIntentId,
  registerId,
  registerSalePaymentId,
  dispatch,
  setDisableCNP,
  terminalMonitoringInstance,
  terminalInfo,
}) => {
  const getErrorMessage = useErrorMessages()
  const { deviceId, deviceModel } = terminalInfo
  useEffect(() => {
    setDisableCNP(true)
    captureTransactionWithRetry({
      registerId,
      paymentIntentId,
      registerSalePaymentId,
    })
      .then(data => {
        terminalMonitoringInstance?.sendEvent(TERMINAL_EVENT.COMPLETE, {
          payment: {
            id: paymentIntentId,
            status: PAYMENT_STATUS.APPROVED,
          },
          terminal: {
            id: deviceId,
            model: deviceModel,
          },
          transactionType: TRANSACTION_TYPE.PAYMENT,
          ...(getTotalSurchargeAmountFromTenders(data.transaction.tenders)
            ? { surcharging: true }
            : {}),
        })
        dispatch({
          type: 'CAPTURE_OK',
          transaction: data.transaction,
        })
      })
      .catch((error: SwiperError) => {
        // track the error
        trackLSPayServerError(
          '[lspay-server-driven] failed to capture transaction',
          error,
          {
            paymentIntentId,
            registerSalePaymentId,
          },
          TAG.payment
        )
        dispatch({
          type: 'ERROR',
          errorMessage: getErrorMessage(LSPAY_ERROR.DEFAULT_PAYMENT),
          swiperError: error,
        })
        return
      })
  }, [
    paymentIntentId,
    registerId,
    registerSalePaymentId,
    dispatch,
    setDisableCNP,
    terminalMonitoringInstance,
    deviceId,
    deviceModel,
    getErrorMessage,
  ])

  return <Processing />
}
